export const en = {
  dashboard: 'Dashboard',
  category: 'Category',
  service: 'Service',
  department: 'Department',
  tickets: 'Tickets',
  complain: 'Issue Categories',
  provider: 'Provider',
  activity_logs: 'Activity Logs',
  main: 'Main',
  add: 'Add',
  update: 'Update',
  delete: 'Delete',
  edit: 'Edit',
  view: 'View',
  activity_logs_subtitle: 'Monitor system actions for audit and debugging',
  name: 'Name',
  id: 'ID',
  actions: 'Actions',
  search: 'Search',
  search_tickets: 'Search tickets...',
  cancel: 'Cancel',
  processing: 'Processing...',
  loading: 'Loading...',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  no_data: 'No data available',
  ticket_no: 'Ticket No.',
  created_date_time: 'Created Date & Time',
  closed_resolved_date_time: 'Closed / Resolved Date & Time',
  ticket_status: 'Ticket Status',
  service_vertical: 'Service',
  issue_type_complaint_reason: 'Issue Type',
  customer_id_mobile: 'Customer ID / Mobile',
  agent_name: 'Agent Name',
  aging_duration: 'Aging Duration',
  aging_category: 'Aging Category',
  ticket_handled_by: 'This ticket is currently being handled by:',
  unassigned: 'Unassigned',
  latest_note_comment: 'Latest Note / Comment',
  resolution_reason_closing_note: 'Resolution Reason / Closing Note',
  channel: 'Channel',
  complainer_name: 'Complainer Name',
  complainer_number: 'Complainer Number',
  all_channels: 'All Channels',
  all_providers: 'All Providers',
  all_status: 'All Status',
  no_providers_available: 'No providers available',
  select_service_first: 'Select Service first',
  merchant_panel: 'SG Customer Support',
  user_management: 'User Management',
  customers: 'Customers',
  contact_us: 'Contact Us',
  contact_us_list: 'Contact Us List',
  return: 'Return Orders',
  order_return: 'Return Orders',
  ecom_orders: 'Return Orders',
  return_request: 'Return Request',
  return_request_details: 'Return Request Details',
  filter_start_date: 'Filter Start Date',
  filter_end_date: 'Filter End Date',
  apply: 'Apply',
  reset: 'Reset',
  show: 'Show',
  entries: 'entries',
  return_number: 'Return Number',
  order_number: 'Order Number',
  customer_name: 'Customer Name',
  return_request_date: 'Return Request Date',
  return_request_time: 'Return Request Time',
  items_count: 'Items Count',
  return_amount: 'Return Amount',
  refund_amount: 'Refund Amount',
  return_status: 'Return Status',
  mobile: 'Mobile',
  customer_address: 'Customer Address',
  billed_to: 'Billed To',
  return_reason: 'Return Reason',
  category: 'Category',
  return_items: 'Return Items',
  product: 'Product',
  price: 'Price',
  return_qty: 'Return Qty',
  total_return_amount: 'Total Return Amount',
  return_shipping_fee: 'Return Shipping Fee',
  total_refund_amount: 'Total Refund Amount',
  status_history: 'Status History',
  customer_details: 'Customer Details',
  original_order_info: 'Original Order Info',
  order_date: 'Order Date',
  order_total_amount: 'Order Total Amount',
  warehouse_details: 'Warehouse Details',
  code: 'Code',
  address: 'Address',
  city: 'City',
  settings: 'Settings',
  profile: 'Profile',
  select_service: 'Select Service',
  select_provider: 'Select Provider',
  select_department: 'Select Department',
  select_category: 'Select Category',
  search_service: 'Search Service',
  search_provider: 'Search Provider',
  search_department: 'Search Department',
  search_category: 'Search Category',
  service_list: 'Service List',
  department_list: 'Department List',
  provider_list: 'Provider List',
  category_list: 'Category List',
  ticket_list: 'Ticket List',
  complain_list: 'Issue Categories List',
  select: 'Select',
  role: 'Role',
  generate_ticket: 'Generate Ticket',
  category_name: 'Category Name',
  service_name: 'Service Name',
  service_name_ar: 'Service Name (Arabic)',
  department_name: 'Department Name',
  department_name_ar: 'Department Name',
  provider_name: 'Provider Name',
  enter_category_name: 'Enter category name',
  enter_service_name: 'Enter service name',
  enter_department_name: 'Enter department name',
  enter_provider_name: 'Enter provider name',
  issue_en: 'Issue (English)',
  issue_ar: 'Issue (Arabic)',
  enter_issue: 'Enter issue',
  enter_phone_number: 'Enter Phone Number',
  country_code: 'Country Code',
  phone_number: 'Phone Number',
  select_country_code: 'Select country code',
  enter_your_phone_number: 'Enter your phone number',
  phone_number_required: 'Phone number is required',
  phone_number_digits_only: 'Phone number must contain only digits',
  phone_number_too_short: 'Phone number is too short',
  sending: 'Sending...',
  send_otp: 'Send OTP',
  verify_otp: 'Verify OTP',
  verifying: 'Verifying...',
  otp_sent_message: "We've sent a 6-digit code to",
  please_enter_complete_otp: 'Please enter complete OTP',
  resend_otp: 'Resend OTP',
  resend_otp_in: 'Resend OTP in',
  service_provider: 'Service Provider',
  required: 'is required',
  all_services: 'All Services',
  all_categories: 'All Categories',
  filter_by_category: 'Filter by Category',
  all_departments: 'All Departments',
  no_providers: 'No providers available',
  admin_dashboard: 'Admin Dashboard',
  refresh: 'Refresh',
  refreshing: 'Refreshing...',
  refresh_dashboard: 'Refresh Dashboard',
  open_tickets: 'OPEN TICKETS',
  resolved_tickets: 'RESOLVED TICKETS',
  rejected_tickets: 'REJECTED TICKETS',
  service_wise_summary: 'Service-wise Summary',
  loading_service_summary: 'Loading service summary...',
  total_count: 'Total Tickets:',
  open: 'Open',
  open_label: 'open:',
  pending: 'Pending',
  in_progress: 'In Progress',
  in_progress_label: 'In progress:',
  rejected: 'Rejected',
  rejected_label: 'rejected:',
  resolved: 'Resolved',
  resolved_label: 'Resolved:',
  resolved_at: 'Resolved At',
  no_service_data_available: 'No service data available',
  tickets_by_service: 'Tickets by Service',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  ticket_distribution_by_status: 'Ticket Distribution by Status',
  tickets_status_by_service: 'Tickets Status by Service',
  escalated: 'Escalated',
  showing: 'Showing',
  to: 'to',
  from_date: 'From Date',
  to_date: 'To Date',
  of: 'of',
  entries: 'entries',
  previous: 'Previous',
  next: 'Next',
  english: 'English',
  arabic: 'Arabic',
  change_password: 'Change Password',
  current_password: 'Current Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  changing: 'Changing...',
  verifying_password: 'Verifying...',
  enter_new_password_below: 'Enter your new password below',
  enter_current_password: 'Enter current password',
  enter_new_password: 'Enter new password',
  confirm_new_password: 'Confirm new password',
  current_password_required: 'Current password is required',
  new_password_required: 'New password is required',
  confirm_password_required: 'Please confirm your password',
  password_min_length: 'Password must be at least 6 characters',
  passwords_do_not_match: 'Passwords do not match',
  email_required: 'Email is required',
  invalid_email: 'Please enter a valid email address',
  password_changed: 'Password changed successfully',
  password_change_failed: 'Failed to change password. Please try again.',
  unable_to_retrieve_email: 'Unable to retrieve user email. Please contact support.',
  generic_error: 'An error occurred. Please try again.',
  show_password: 'Show password',
  hide_password: 'Hide password',
  ticket_generate: 'Ticket Generate',
  order: 'Order',
  select_an_order: 'Select an order',
  loading_orders: 'Loading orders...',
  select_service_provider: 'Select Service Provider',
  select_both_service_and_provider: 'Select both Service and Service Provider',
  no_issues_available: 'No issues available',
  select_issue: 'Select Issue',
  loading_issues: 'Loading issues...',
  reason: 'Reason',
  enter_reason: 'Enter Reason',
  adding: 'Adding...',
  add_ticket: 'Add Ticket',
  order_id_label: 'order-id',
  service_label: 'Service',
  service_provider_label: 'Service Provider',
  ticket_details: 'Ticket Details',
  basic_information: 'Basic Information',
  ticket_number: 'Ticket Number',
  created_at: 'Created At',
  service_information: 'Service Information',
  issue_information: 'Issue Information',
  customer_information: 'Customer Information',
  customer_ticket_counts: 'Customer ticket counts',
  email: 'Email',
  phone: 'Phone',
  loading_ticket_details: 'Loading ticket details...',
  orders_loaded_successfully: 'Orders loaded successfully',
  complain_created_successfully: 'Issue Category created successfully!',
  ticket_created_successfully: 'Ticket created successfully!',
  edit_functionality_coming_soon: 'Edit functionality coming soon',
  user_id_required_to_fetch_orders: 'User ID is required to fetch orders',
  please_select_a_service: 'Please select a service',
  please_select_a_provider: 'Please select a provider',
  please_select_an_order: 'Please select an order',
  please_select_an_issue: 'Please select an issue',
  please_enter_issue_in_english: 'Please enter issue in English',
  provider_status_updated_successfully: 'Provider status updated successfully',
  service_status_updated_successfully: 'Service status updated successfully',
  category_status_updated_successfully: 'Category status updated successfully',
  department_status_updated_successfully: 'Department status updated successfully',
  complain_status_updated_successfully: 'Issue Category status updated successfully',
  provider_deleted_successfully: 'Provider deleted successfully',
  provider_added_successfully: 'Provider added successfully',
  provider_updated_successfully: 'Provider updated successfully',
  service_deleted_successfully: 'Service deleted successfully',
  service_added_successfully: 'Service added successfully',
  service_updated_successfully: 'Service updated successfully',
  category_deleted_successfully: 'Category deleted successfully',
  category_added_successfully: 'Category added successfully',
  category_updated_successfully: 'Category updated successfully',
  department_deleted_successfully: 'Department deleted successfully',
  department_added_successfully: 'Department added successfully',
  department_updated_successfully: 'Department updated successfully',
  complain_deleted_successfully: 'Issue Category deleted successfully',
  complain_added_successfully: 'Issue Category added successfully',
  complain_updated_successfully: 'Issue Category updated successfully',
  fetch_failed: 'Failed to fetch data. Please try again.',
  unauthorized: 'Please login to continue',
  access_denied: 'Access Denied',
  access_denied_message: 'You do not have permission to access this section.',
  go_to_dashboard: 'Go to Dashboard',
  update_failed: 'Failed to update. Please try again.',
  delete_failed: 'Failed to delete. Please try again.',
  save_failed: 'Failed to save. Please try again.',
  an_error_occurred: 'An error occurred. Please try again.',
  user_id_not_found: 'User ID not found in response',
  logged_out_successfully: 'Logged out successfully',
  login_successful: 'Login successful!',
  logout: 'Logout',
  welcome_back: 'Welcome Back',
  sign_in_to_continue: 'Sign in to continue to your account',
  email_address: 'Email Address',
  password: 'Password',
  remember_me: 'Remember me',
  forgot_password: 'Forgot Password?',
  sign_in: 'Sign In',
  sending_otp: 'Sending OTP...',
  added_successfully: 'added successfully',
  updated_successfully: 'updated successfully',
  deleted_successfully: 'deleted successfully',
  chat_dashboard: 'Chat Dashboard',
  chat: 'Chat',
  conversations: 'Conversations',
  filters: 'Filters',
  enter_ticket_id: 'Enter ticket ID',
  all_senders: 'All Senders',
  all_status: 'All Status',
  search_messages: 'Search messages...',
  reset: 'Reset',
  apply_filters: 'Apply Filters',
  no_conversations_found: 'No conversations found',
  no_messages: 'No messages',
  close: 'Close',
  loading_messages: 'Loading messages...',
  no_messages_yet: 'No messages yet',
  type_a_message: 'Type a message...',
  select_a_conversation: 'Select a conversation',
  select_conversation_to_view_messages: 'Select a conversation to view messages',
  please_enter_a_message: 'Please enter a message',
  message_sent_successfully: 'Message sent successfully',
  edit_message: 'Edit message',
  delete_message: 'Delete message',
  message_edited: 'edited',
  message_deleted: 'This message was deleted',
  confirm_delete_message: 'This cannot be undone. The customer will no longer see this message.',
  message_updated_successfully: 'Message updated successfully',
  message_deleted_successfully: 'Message deleted successfully',
  just_now: 'Just now',
  m_ago: 'm ago',
  h_ago: 'h ago',
  d_ago: 'd ago',
  sender: 'Sender',
  read_status: 'Read Status',
  ticket_id: 'Ticket ID',
  messages: 'Messages',
  send: 'Send',
  start_conversation_below: 'Start a conversation below',
  no_orders_found_for_service: 'No orders found for this service',
  external_ticket_id: 'External Ticket ID',
  enter_external_ticket_id: 'Enter External Ticket ID',
  update_ticket_status: 'Update Ticket Status',
  new_status: 'New Status',
  select_status: 'Select Status',
  enter_reason_for_status_change: 'Enter Reason for Status Change',
  reason_for_status_change: 'Reason for Status Change',
  please_select_status_and_enter_reason: 'Please select status and enter reason',
  failed_to_upload_attachments: 'Failed to upload attachments',
  uploaded_image: 'Uploaded Image',
  attachments: 'Attachment',
  order_id: 'Order ID',
  image_size_too_large: 'Image size is too large',
  please_select_valid_image: 'Please select a valid image',
  image_uploaded_successfully: 'Image uploaded successfully',
  failed_to_get_image_url: 'Failed to get image URL',
  please_select_image: 'Please select an image',
  no_orders_available: 'No orders available',
  ticket_status_updated_successfully: 'Ticket status updated successfully',
  ticket_report: 'Ticket Report',
  updated_at: 'Updated At',
  estimating_time: 'Estimating Time',
  total_tickets: 'Total Tickets',
  detailed_ticket_analysis: 'Detailed Ticket Analysis',
  customer_name: 'Customer Name',
  closed_at: 'Closed At',
  user_id: 'User ID',
  customer_email: 'Customer Email',
  customer_phone: 'Customer Phone',
  issue: 'Issue',
  issue_reason: 'Issue Reason',
  please_select_status: 'Please select status',
  customer_info: 'Customer Info',
  ticket_resolving_time: 'Ticket Resolving Time',
  compensation_amount: 'Compensation Amount',
  compensation_status: 'Compensation Status',
  compensation_date: 'Compensation Date',
  compensation_information: 'Compensation Information',
  notes: 'Notes',
  save_notes: 'Save Notes',
  add_your_notes_here: 'Add your notes here...',
  notes_updated_successfully: 'Notes updated successfully',
  failed_to_update_notes: 'Failed to update notes',
  notes_history: 'Notes History',
  message: 'Message',
  added_by: 'Added By',
  no_notes_available: 'No notes available',
  add_note: 'Add Note',
  d: 'd',
  h: 'h',
  m: 'm',
  in_progress_tickets: 'In Progress Tickets',
  role_list: 'Role List',
  assign_role_permission: 'Assign Role',
  first_admin_response: 'First Admin Response',
  not_replied_yet: 'Not Replied Yet',
  permission_catalog: 'Permission Catalog',
  permission: 'Permission',
  roles_and_permissions: 'Roles',
  description: 'Description',
  permission_key: 'Permission Key',
  module: 'Module',
  user: 'User',
  permissions: 'Permissions',
  providers: 'Providers',
  user_permission_management: 'User Permission Management',
  user_name: 'User Name',
  user_email: 'User Email',
  module_name: 'Module Name',
  activity_type: 'Activity Type',
  record_id: 'Record ID',
  old_data: 'Old Data',
  new_data: 'New Data',
  role_name: 'Role Name',
  assign_role: 'Assign Role',
  update_role: 'Update Role',
  role_management: 'Role Management',
  role: 'Role',
  customer_management: 'Customer Management',
  browse_and_manage_customers: 'Browse and manage all registered customers',
  add_assign_role: 'Add Assign Role',
  role_unassigned_successfully: 'Role unassigned successfully',
  role_assigned_successfully: 'Role assigned successfully',
  assignment_updated_successfully: 'Role updated successfully',
  status_updated_successfully: 'Status updated successfully',
  role_status_updated_successfully: 'Role status updated successfully',
  edit_ticket_details: 'Edit Ticket Details',
  ticket_updated_successfully: 'Ticket updated successfully',
  failed_to_update_ticket: 'Failed to update ticket',
};
